import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

// TS port of the source (Falah) app's pages/reports/procurement/RequestPipelineReport.jsx.
const STATUS_OPTIONS: ReportOption[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'pending_approval', label: 'Pending Approval' },
  { value: 'pending_second_approval', label: 'Pending Second Approval' },
  { value: 'approved', label: 'Approved' },
  { value: 'rejected', label: 'Rejected' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'reference', label: 'Reference' },
  { key: 'title', label: 'Title' },
  { key: 'item_name', label: 'Item' },
  { key: 'requester', label: 'Requester' },
  { key: 'estimated_cost', label: 'Est. Cost', align: 'right', type: 'money' },
  { key: 'status', label: 'Status' },
  { key: 'final_outcome', label: 'Outcome' },
  { key: 'final_outcome_at', label: 'Decided' },
];

export function RequestPipelineReport() {
  return (
    <ReportView
      title="Purchase Request Pipeline"
      description="Every purchase request with approval status and final outcome."
      endpoint="/reports/procurement/request-pipeline"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
